import SvgIcon from '@mui/material/SvgIcon'

export const Falconx = (props) => (
  <SvgIcon {...props} viewBox="0 0 500 500">
    <path d="M 324.749 305.921 L 278.659 374.338 L 333.967 456.502 L 426.877 456.502 L 324.749 305.921 Z M 333.967 58.459 L 278.76 140.808 L 324.749 209.059 L 426.877 58.459 L 333.967 58.459 Z M 157.382 58.459 L 63.936 58.459 L 199.765 260.274 L 68.238 456.502 L 161.705 456.502 L 290.989 260.316 L 157.382 58.459 Z"></path>
  </SvgIcon>
)

export default Falconx
